import rilletLogo from '../../assets/logos/rillet.png';
import { SourceCard, type SourceConfig } from './SourceCard';
import type { IntegrationsState } from './model';

const config: SourceConfig = {
  name: 'rillet', logo: rilletLogo, logoFill: true, role: 'Ledger · read-only',
  purpose: 'Your ledger of record: open AR, customers and cleared payments.',
  summary: 'Alder reads open balances, customers and cleared payments from Rillet, so reminders match your ledger.',
  reassurance: 'Read-only: Alder never writes to Rillet.',
  fields: [{ key: 'apiKey', label: 'API key', secret: true }],
};

export function RilletCard(props: { state: IntegrationsState; onChanged: () => Promise<void>; onSyncNow: () => void;
  syncing: boolean }) {
  return <SourceCard config={config} {...props}/>;
}
